export function getPVFARate(loantype, period) {
  var pvfarate = {};
  var selected_rate = 0;
  // jijenge loan
  if (loantype === 1) {
    pvfarate = {
      1: 0.99,
      2: 1.97,
      3: 2.93,
      4: 3.89,
      5: 4.83,
      6: 5.75,
      7: 6.67,
      8: 7.58,
      9: 8.47,
      10: 9.35,
      11: 10.23,
      12: 11.09,
      13: 11.94,
      14: 12.78,
      15: 13.61,
      16: 14.43,
      17: 15.24,
      18: 16.04,
      19: 16.83,
      20: 17.61,
      21: 18.38,
      22: 19.14,
      23: 19.89,
      24: 20.63,
      25: 21.36,
      26: 22.09,
      27: 22.8,
      28: 23.51,
      29: 24.21,
      30: 24.9,
      31: 25.58,
      32: 26.25,
      33: 26.91,
      34: 27.57,
      35: 28.22,
      36: 28.85,
      37: 29.49,
      38: 30.11,
      39: 30.73,
      40: 31.33,
      41: 31.94,
      42: 32.53,
      43: 33.11,
      44: 33.69,
      45: 34.27,
      46: 34.83,
      47: 35.39,
      48: 35.94,
      49: 36.48,
      50: 37.02,
      51: 37.55,
      52: 38.08,
      53: 38.59,
      54: 39.1,
      55: 39.61,
      56: 40.11,
      57: 40.6,
      58: 41.09,
      59: 41.57,
      60: 42.04,
      61: 42.51,
      62: 42.97,
      63: 43.43,
      64: 43.88,
      65: 44.33,
      66: 44.77,
      67: 45.2,
      68: 45.63,
      69: 46.06,
      70: 46.48,
      71: 46.89,
      72: 47.3,
      73: 47.7,
      74: 48.1,
      75: 48.5,
      76: 48.89,
      77: 49.27,
      78: 49.65,
      79: 50.02,
      80: 50.39,
      81: 50.76,
      82: 51.12,
      83: 51.48,
      84: 51.83,
      85: 52.18,
      86: 52.52,
      87: 52.86,
      88: 53.2,
      89: 53.53,
      90: 53.85,
      91: 54.18,
      92: 54.5,
      93: 54.81,
      94: 55.12,
      95: 55.43,
      96: 55.73,
    };
  } else if (loantype === 2) {
    // fosa pride
    pvfarate = {
      1: 0.99,
      2: 1.96,
      3: 2.91,
      4: 3.85,
      5: 4.78,
      6: 5.7,
      7: 6.6,
      8: 7.49,
      9: 8.36,
      10: 9.22,
      11: 10.07,
      12: 10.91,
      13: 11.73,
      14: 12.54,
      15: 13.34,
      16: 14.13,
      17: 14.91,
      18: 15.67,
      19: 16.43,
      20: 17.17,
      21: 17.9,
      22: 18.62,
      23: 19.33,
      24: 20.03,
      25: 20.72,
      26: 21.4,
      27: 22.07,
      28: 22.73,
      29: 23.38,
      30: 24.02,
      31: 24.65,
      32: 25.27,
      33: 25.88,
      34: 26.48,
      35: 27.08,
      36: 27.66,
      37: 28.24,
      38: 28.81,
      39: 29.36,
      40: 29.92,
      41: 30.46,
      42: 30.99,
      43: 31.52,
      44: 32.04,
      45: 32.55,
      46: 33.06,
      47: 33.55,
      48: 34.04,
    };
  }

  selected_rate = pvfarate[period];

  return selected_rate;

  //fosa pride
}

export function Calculate(amount, period, loan_type, payment_type, rate) {
  // var amount = parseFloat(document.getElementById("amount").value );
  // var period = parseInt(document.getElementById("period").value );

  // loan type 1 - jijenge, 2 - fosa pride
  // var loan_type = parseInt(document.getElementById("loan_type").value );

  // payment type 1 - reducing balance, 2 - constant amount
  // var payment_type = parseInt(document.getElementById("payment_type").value );

  // var rate = parseFloat(document.getElementById("rate").value );
  let monthly = 0.0;
  const form_fee = 100;
  let principal_bal = amount + form_fee;
  const table = [];
  // let
  /*
    console.log('loan_type',loan_type);
    console.log('amount',amount);
    console.log('period',period);
    console.log('rate',rate);
    */

  // rate = rate / 100 / 12;

  // Reducing Balance
  if (payment_type === 1) {
    rate = rate / 100;
    monthly = Math.round(amount / period / 100) * 100;

    var m = 0; // number of months

    while (m < period) {
      var interest = Math.round(principal_bal * rate);

      if (m === period - 1) {
        monthly = principal_bal;
        principal_bal = 0;
      } else {
        principal_bal = Math.round(principal_bal - monthly);
      }

      // build table: m + 1, principal, interest, amount
      //  console.log(m + 1, monthly, interest, principal_bal)
      table.push({
        month: m + 1,
        principal: monthly,
        interest: interest,
        balance: principal_bal,
      });
      m++;
    }
  } else {
    // Fixed / Constant Amount

    var pvfa_rate = getPVFARate(loan_type, period);
    // console.log('pvfa_rate',pvfa_rate);

    rate = rate / 100;
    monthly = Math.ceil(amount / pvfa_rate);

    let m = 0; // number of months

    while (m < period) {
      let interest = Math.round(principal_bal * rate);

      if (m === period - 1) {
        monthly = principal_bal;
        principal_bal = Math.round(principal_bal + interest - monthly);
      } else {
        principal_bal = Math.round(principal_bal + interest - monthly);
      }

      // build table: m + 1, principal, interest, amount
      // console.log(m + 1, monthly, interest, principal_bal)
      table.push({
        month: m + 1,
        principal: monthly,
        interest: interest,
        balance: principal_bal,
      });
      m++;
    }
  }
  return table;
}
